import React, { useEffect, useState } from "react";
import classes from "./reportAProblemDone.module.css";
import modalClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import { Button } from "../../../../../stories/Button/Button";

function ReportAProblemDone({ show, setShow }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, []);

  return (
    <>
      <style>{`
      .modal-body{
        padding:0px 32px;
      }
              @media screen and (max-width: 580px) {
            .modal .modal-dialog {
              width: 90% !important;
              margin: 0px 10%;
            }
        }
            @media screen and (max-width: 768px) {
                .${modalClasses.body} {
                  padding:0px 24px;
                }
                .${modalClasses.header} {
                    margin:24px;
                  }
            }

      `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        headerStyles={{
          marginBottom: "0px",
          paddingBottom: "8px",
        }}
        borderRadius={"20px"}
        width={"509px"}
        showCloseIcon
      >
        <div className={classes.modalContent}>
          <h4 style={{ ...Fonts.h4, color: Colors.neutralShadesOfNero }}>
            Report a problem
          </h4>
          <div className={[isMobile ? classes.mb24 : classes.mb32].join(" ")}>
            <p
              className={[classes.mt8].join(" ")}
              style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
            >
              Thanks for your feedback. We’re working hard to solve any
              difficulties that might happen. We’ll get back to you.
            </p>
            <p
              className={[classes.mb24].join(" ")}
              style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
            >
              You can also contact us directly if your problen wasn’t solved.
            </p>
            <Button
              primary={false}
              label={"Contact Lytesnap"}
              size={"Large"}
              customStyle={{
                width: isMobile ? "100%" : "max-content",
              }}
            />
          </div>
        </div>
      </ModalSkeleton>
    </>
  );
}

export default ReportAProblemDone;
